import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ModalConfirmComponent } from '../modal-confirm/modal-confirm.component';

export const APP_ONLY_FEATURE_TITLE = 'Disponível apenas no aplicativo Omni Banco';

export const APP_ONLY_CHANGE_PASSWORD = 'Acesse seu app Omni Banco para alterar a senha de acesso da sua conta.';
export const APP_ONLY_CHANGE_DIGITAL_SIGNATURE = 'Acesse seu app Omni Banco para alterar sua assinatura eletrônica.';
export const APP_ONLY_REDEFINE_PASSWORD = 'Acesse seu app Omni Banco para redefinir a senha de acesso da sua conta.';

export const PASSWORD_BLOCKED_TITLE = 'Sua senha de acesso está bloqueada';
export const PASSWORD_BLOCKED_NOTICE = [
	'Por segurança, sua senha foi bloqueada após tentativas incorretas.',
	'O desbloqueio e a criação de uma nova senha são feitos apenas no aplicativo Omni Banco, na opção Esqueci minha senha da tela de acesso.',
	'Depois de redefinir pelo app, você volta a acessar o internet banking normalmente.',
	'Precisa de ajuda? Fale com a gente pelo 4004 3500 (capitais) ou 0800 701 3500 (demais regiões).'
];

@Injectable()
export class AppOnlyFeatureService {

	constructor(private dialog: MatDialog) {
	}

	openNotice(text: string | string[], title: string = APP_ONLY_FEATURE_TITLE, width: string = '350px'): void {
		this.dialog.open(ModalConfirmComponent, {
			width: width,
			data: {
				title: title,
				text: Array.isArray(text) ? text.join('<br><br>') : text,
				hideBackButton: true,
				confirmButton: 'Entendi',
			}
		});
	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/shared/app-only-feature/app-only-feature.service.ts